import type { FC } from 'react'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import { useGatedContent } from 'contexts/gatedContent'

import type { Lesson } from '@segment/api/routes/growthMasters/queries'

import Card from '../../components/Card'

interface CardsProps {
  lessons: Lesson[]
}
const Cards: FC<CardsProps> = ({ lessons }) => {
  const { showContent } = useGatedContent()

  return (
    <SectionBase variant="noCopy">
      <Section.Contents>
        <ColumnTrack
          columns={1}
          overrides={{
            lg: 3,
          }}
        >
          {lessons.map((card, key) => (
            <Card
              slug={card.slug}
              title={card.title}
              speaker={card.speaker}
              badges={card.badges}
              key={card.title + key}
              description={card.shortDescription}
              gated={!showContent}
            />
          ))}
        </ColumnTrack>
      </Section.Contents>
    </SectionBase>
  )
}

export default Cards
